
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("dPS3E"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("jQg8s"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _42Yu6BsWIj",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $cozmU.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $cozmU.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $8s9DV.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $kBr4q.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $kBr4q.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("dPS3E", function(module, exports) {

let $a129f88ad1bb7bc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a129f88ad1bb7bc0$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("jQg8s", function(module, exports) {

let $e71f63cf876aeaf7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e71f63cf876aeaf7$var$load("kT6dz"),
    $e71f63cf876aeaf7$var$load("7SZ1R"),
    $e71f63cf876aeaf7$var$load("kuBVv"),
    $e71f63cf876aeaf7$var$load("2TRyz"),
    $e71f63cf876aeaf7$var$load("lXUHS"),
    $e71f63cf876aeaf7$var$load("7tWfn"),
    $e71f63cf876aeaf7$var$load("hn3wf"),
    $e71f63cf876aeaf7$var$load("d8Sxi"),
    $e71f63cf876aeaf7$var$load("hUbK8"),
    $e71f63cf876aeaf7$var$load("gIig2"),
    $e71f63cf876aeaf7$var$load("5KHgm"),
    $e71f63cf876aeaf7$var$load("alg5Q"),
    $e71f63cf876aeaf7$var$load("dx5gy"),
    $e71f63cf876aeaf7$var$load("3i6cl"),
    $e71f63cf876aeaf7$var$load("2mGc6"),
    $e71f63cf876aeaf7$var$load("1R53K"),
    $e71f63cf876aeaf7$var$load("anA6E"),
    $e71f63cf876aeaf7$var$load("kccW9"),
    $e71f63cf876aeaf7$var$load("iPvQ1"),
    $e71f63cf876aeaf7$var$load("8yk9S"),
    $e71f63cf876aeaf7$var$load("iOfkQ"),
    $e71f63cf876aeaf7$var$load("eeYoU"),
    $e71f63cf876aeaf7$var$load("do0Fh"),
    $e71f63cf876aeaf7$var$load("1cQg7"),
    $e71f63cf876aeaf7$var$load("fEHF5"),
    $e71f63cf876aeaf7$var$load("4XoWv"),
    $e71f63cf876aeaf7$var$load("2PVCX"),
    $e71f63cf876aeaf7$var$load("dxcsb"),
    $e71f63cf876aeaf7$var$load("jqoep"),
    $e71f63cf876aeaf7$var$load("6wr18"),
    $e71f63cf876aeaf7$var$load("59hV4"),
    $e71f63cf876aeaf7$var$load("3R4oU"),
    $e71f63cf876aeaf7$var$load("kwaPJ"),
    $e71f63cf876aeaf7$var$load("3ayyN"),
    $e71f63cf876aeaf7$var$load("aMsb0"),
    $e71f63cf876aeaf7$var$load("2PXrC"),
    $e71f63cf876aeaf7$var$load("3g5Gh"),
    $e71f63cf876aeaf7$var$load("eIINb"),
    $e71f63cf876aeaf7$var$load("2N4Hm"),
    $e71f63cf876aeaf7$var$load("2xUJh"),
    $e71f63cf876aeaf7$var$load("a8glC"),
    $e71f63cf876aeaf7$var$load("gfZAh"),
    $e71f63cf876aeaf7$var$load("kE76L"),
    $e71f63cf876aeaf7$var$load("4x9Jx"),
    $e71f63cf876aeaf7$var$load("ea3NB"),
    $e71f63cf876aeaf7$var$load("by9qp"),
    $e71f63cf876aeaf7$var$load("i6gwF"),
    $e71f63cf876aeaf7$var$load("6vqGz"),
    $e71f63cf876aeaf7$var$load("ffEVr"),
    $e71f63cf876aeaf7$var$load("gaT5l"),
    $e71f63cf876aeaf7$var$load("2Vm3g"),
    $e71f63cf876aeaf7$var$load("kDTjZ"),
    $e71f63cf876aeaf7$var$load("7jwjb"),
    $e71f63cf876aeaf7$var$load("cenKA"),
    $e71f63cf876aeaf7$var$load("Wowvf"),
    $e71f63cf876aeaf7$var$load("lkxmG"),
    $e71f63cf876aeaf7$var$load("dFbDj"),
    $e71f63cf876aeaf7$var$load("hhss7"),
    $e71f63cf876aeaf7$var$load("7EorR"),
    $e71f63cf876aeaf7$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.2ca2032b.js.map
